"use client";

import "./globals.css";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body>
        <main id="main" className="container">
          <section
            style={{
              paddingBlock: "96px",
              display: "grid",
              gap: "20px",
              maxWidth: "640px",
            }}
          >
            <span className="mono-label">CHYBA — NEOČEKÁVANÝ STAV</span>
            <h1 className="section-heading">Něco se nepodařilo načíst</h1>
            <p className="lead">
              Zkuste stránku načíst znovu. Pokud problém přetrvává, napište nám
              na info@obsahproai.acomputer.cz.
            </p>
            <button
              type="button"
              className="btn"
              onClick={reset}
              style={{ justifySelf: "start" }}
            >
              Zkusit znovu
            </button>
          </section>
        </main>
      </body>
    </html>
  );
}
